import React, { useState } from "react";
import axios from "axios";
import Loader from "../../components/Loader";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import AdminNav from "./AdminNav";
import Sidebar from "./Sidebar";
import { FaBarsStaggered } from "react-icons/fa6";
import { useParams, useLocation } from "react-router-dom";
const AddClass = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("admintoken");

  const [loading, setLoading] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { fundId } = useParams();
  const location = useLocation();
  const fundName = location.state?.fundName;
  const [formData, setFormData] = useState({
    fundId: fundId,
    class: "",
    cusip: "",
    isin: "",
    inception: "",
    currency: "",
    navCalculation: "",
    subscription: "",
    redemption: "",
    redemptionFee: "",
  });

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const dataToSend = {
        ...formData,
        redemptionFee: formData.redemptionFee
          ? parseFloat(formData.redemptionFee) / 100
          : 0,
      };
      const res = await axios.post(
        `${process.env.REACT_APP_API}/api/v1/fund/add-fund-class`,
        dataToSend,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.success) {
        toast.success(res.data.message);
        navigate("/dashboard/admin/fund-management");
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Failed to add class");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <div className="wrapper d-flex align-items-stretch">
        <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
        <div id="content" className="px-2">
          <button
            type="button"
            id="openSidebar"
            onClick={toggleSidebar}
            className="bars-btn"
          >
            <FaBarsStaggered />
          </button>
          <AdminNav />
          <div className="add-bank-sec">
            <h3 className="mb-4">Add new class for {fundName} </h3>
            <form onSubmit={handleSubmit} className="add-bank-sub">
              <div className="add-bank-card w-100">
                <h5>Class Name</h5>
                <input
                  name="class"
                  value={formData.class}
                  onChange={handleChange}
                  className="add-bank-input"
                  placeholder="Enter class name"
                  required
                />
              </div>

              <div className="add-bank-card w-100">
                <h5>CUSIP</h5>
                <input
                  name="cusip"
                  value={formData.cusip}
                  onChange={handleChange}
                  className="add-bank-input"
                  placeholder="Enter CUSIP"
                />
              </div>

              <div className="add-bank-card w-100">
                <h5>ISIN</h5>
                <input
                  name="isin"
                  value={formData.isin}
                  onChange={handleChange}
                  className="add-bank-input"
                  placeholder="Enter ISIN"
                />
              </div>

              <div className="add-bank-card w-100">
                <h5>Inception Date</h5>
                <input
                  type="date"
                  name="inception"
                  value={formData.inception}
                  onChange={handleChange}
                  className="add-bank-input"
                />
              </div>

              <div className="add-bank-card w-100">
                <h5>Currency</h5>
                <select
                  name="currency"
                  value={formData.currency}
                  onChange={handleChange}
                  className="add-bank-input"
                  required
                >
                  <option value="">Select currency</option>
                  <option value="USD">USD</option>
                  <option value="EUR">EUR</option>
                  <option value="GBP">GBP</option>
                  <option value="SGD">SGD</option>
                  <option value="HKD">HKD</option>
                </select>
              </div>

              <div className="add-bank-card w-100">
                <h5>NAV Calculation</h5>
                <select
                  name="navCalculation"
                  value={formData.navCalculation}
                  onChange={handleChange}
                  className="add-bank-input"
                  required
                >
                  <option value="">Select frequency</option>
                  <option value="Daily">Daily</option>
                  <option value="Weekly">Weekly</option>
                  <option value="Monthly">Monthly</option>
                </select>
              </div>

              <div className="add-bank-card w-100">
                <h5>Subscription</h5>
                <select
                  name="subscription"
                  value={formData.subscription}
                  onChange={handleChange}
                  className="add-bank-input"
                  required
                >
                  <option value="">Select frequency</option>
                  <option value="Daily">Daily</option>
                  <option value="Weekly">Weekly</option>
                  <option value="Monthly">Monthly</option>
                  <option value="Yearly">Yearly</option>
                </select>
              </div>

              <div className="add-bank-card w-100">
                <h5>Redemption</h5>
                <select
                  name="redemption"
                  value={formData.redemption}
                  onChange={handleChange}
                  className="add-bank-input"
                  required
                >
                  <option value="">Select frequency</option>
                  <option value="Daily">Daily</option>
                  <option value="Weekly">Weekly</option>
                  <option value="Monthly">Monthly</option>
                  <option value="Yearly">Yearly</option>
                </select>
              </div>

              <div className="add-bank-card w-100">
                <h5>Redemption Fee (%)</h5>
                <input
                  type="number"
                  name="redemptionFee"
                  value={formData.redemptionFee}
                  onChange={handleChange}
                  className="add-bank-input"
                  placeholder="e.g. 2"
                />
              </div>

              <button type="submit" className="btn btn-lg btn-primary mt-3">
                Add Class
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddClass;
